<template>
  <section class="hero">
    <div class="wrap">
      <div class="head c">
        <a class="pill" href="#adverpeople" @click.prevent="$emit('go', '#adverpeople')">
          <b>New</b> Adverpeople analytics is live
        </a>
        <h1 class="h1">
          Manage, automate and measure<br />
          <span class="accent">every screen you own.</span>
        </h1>
        <p class="lede">Run your screens, sell the airtime and see who watched.</p>
        <div class="cta-row">
          <a class="btn btn-red" href="#/home" data-auth="register">Get Adverpost</a>
          <a class="btn btn-line" href="#demo" data-demo>Book a demo</a>
        </div>
        <div class="checks">
          <span v-for="(c, i) in checks" :key="i">
            <check-icon />
            <span v-if="c.cls" :class="c.cls">{{ c.label }}</span>
            <template v-else>{{ c.label }}</template>
          </span>
        </div>
      </div>

      <div class="stage">
        <div class="badge">
          <span class="dot"></span>
          <div>
            <small>New marketplace booking request</small>
            <b>Barossa Wine Show · $1,240</b>
          </div>
        </div>
        <div class="screen">
          <div
            class="apx"
            data-app="dashboard"
            role="img"
            aria-label="Adverpost dashboard showing display status, content totals and payment status"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CheckIcon from "./CheckIcon.vue";

export default {
  name: "HeroSection",
  components: { CheckIcon },
  data() {
    return {
      checks: [
        { label: "Unlimited screens" },
        { label: "Cloud media library" },
        { label: "Works offline" },
        { label: "Local support", cls: "loc-support" },
      ],
    };
  },
};
</script>
